import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Layout } from '@widgets/consultations';
import {
  AvailablePeriodAddress,
  AvailablePeriodCost,
  AvailablePeriodDate,
  AvailablePeriodDuration,
  AvailablePeriodStatus,
  AvailablePeriodTime,
  AvailablePeriodType,
  useAvailablePeriodLoader,
} from '@features/avaialble-periods';
import {
  ConsultationAddress,
  ConsultationCost,
  ConsultationDate,
  ConsultationDuration,
  ConsultationSeller,
  ConsultationStatus,
  ConsultationTime,
  ConsultationType,
  Row,
  useConsultationLoader,
} from '@features/consultations';
import { MoveButton, useChangeTime } from '@features/shedules';
import { ArrowRight } from '@shared/assets';
import { Card, LargeHeader } from '@shared/ui';
import { useAvailablePeriod } from '@src/entities/available-periods';
import { useConsultation } from '@src/entities/consultations';
import { ModalLarge } from 'library/components/common';
import * as st from './styles.module.scss';

interface MoveParams {
  consultationId: number;
  coachId: number;
  mode: string;
  availablePeriodId: number;
}

export const MoveSummaryModal: React.FC = () => {
  const { code, moveParams = '' } = useParams<{ [x: string]: string }>();
  const navigate = useNavigate();
  const { consultationId, coachId, availablePeriodId, mode }: MoveParams = JSON.parse(moveParams);

  useConsultationLoader(consultationId);
  useAvailablePeriodLoader(availablePeriodId);

  const { consultation } = useConsultation(consultationId);
  const { availablePeriod } = useAvailablePeriod(availablePeriodId);

  const onClose = () => {
    navigate(`/consultations/${code}/consultation/${consultationId}`);
  };

  const { onChange, loading } = useChangeTime(consultationId, availablePeriodId, onClose);

  return (
    <ModalLarge isOpen disableHeader onRequestClose={onClose}>
      <LargeHeader
        title="Консультация"
        onClose={onClose}
        right={<MoveButton onClick={onChange} disabled={loading} />}
      />
      <Layout
        User={<ConsultationSeller id={consultationId} />}
        Consultation={
          <div className={st.summary}>
            <Card className={st.consultation__card}>
              <Row title="Тип">
                <ConsultationType id={consultationId} />
              </Row>
              <Row title="Статус" hideBackground>
                <ConsultationStatus id={consultationId} />
              </Row>
              <Row title="Дата">
                <ConsultationDate id={consultationId} />
              </Row>
              <Row title="Время">
                <ConsultationTime id={consultationId} />
              </Row>
              <Row title="Длительность">
                <ConsultationDuration id={consultationId} />
              </Row>
              <Row title="Стоимость">
                <ConsultationCost id={consultationId} />
              </Row>

              {consultation?.type === 'OF' && (
                <Row title="Адрес">
                  <ConsultationAddress id={consultationId} />
                </Row>
              )}
            </Card>
            <div className={st.summary__arrow}>
              <ArrowRight />
            </div>
            <Card className={st.consultation__card}>
              <Row title="Тип">
                <AvailablePeriodType mode={mode} />
              </Row>
              <Row title="Статус">
                <AvailablePeriodStatus />
              </Row>
              <Row title="Дата">
                <AvailablePeriodDate id={availablePeriodId} />
              </Row>
              <Row title="Время">
                <AvailablePeriodTime id={availablePeriodId} />
              </Row>
              <Row title="Длительность">
                <AvailablePeriodDuration id={availablePeriodId} />
              </Row>
              <Row title="Стоимость">
                <AvailablePeriodCost id={availablePeriodId} />
              </Row>

              {availablePeriod?.status.indexOf('OF') !== -1 && (
                <Row title="Адрес">
                  <AvailablePeriodAddress id={availablePeriodId} />
                </Row>
              )}
            </Card>
          </div>
        }
      />
    </ModalLarge>
  );
};
